<template>
  <div class="serveIndex">
    <div class="flexCont">
      <div class="leftSide">
        <div class="leftHead flex-b-c mb20">
          <span class="headName">
            <i class="el-icon-folder"></i>
            科技服务
          </span>
          <i class="el-icon-plus" @click="addType"></i>
        </div>
        <div v-for="(item, index) in leftList" :key="index" :class="[{'cur':index == leftIndex},'leftItem']" @click="clickItem(index)">
          <span>{{ item.name }}</span>
          <el-dropdown @command="handleCommand($event,item)">
            <i class="el-icon-more"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit">编辑</el-dropdown-item>
              <el-dropdown-item command="del">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="rightSide">
        <el-form :inline="true" ref="formRef" :model="search_form" size="small">
          <!-- <el-form-item label="服务项目" class="search_item">
            <el-input v-model="search_form.name" placeholder="请输入服务项目"></el-input>
          </el-form-item> -->
          <el-form-item>
            <!-- <el-button type="" class="mr-10" icon="el-icon-refresh" @click="operation('reset')">重置</el-button> -->
            <!-- <el-button type="primary" icon="el-icon-search" @click="operation('search')">查询</el-button> -->
            <el-button type="primary" icon="el-icon-plus" @click="operation('add')">新增服务</el-button>
          </el-form-item>
        </el-form>

        <el-table v-loading="loading" :data="tableData" row-key="id" :default-expand-all="isExpandAll"
          :key="treeKey" :tree-props="{ children: 'children', hasChildren: children > 0 }">
          <el-table-column prop="name" label="服务项目" min-width="200" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="createBy" label="添加人" align="center"></el-table-column>
          <el-table-column  prop="createTime" label="创建时间" align="center" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime | timestampFormatDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" class-name="small-padding fixed-width" min-width="200">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="handleAdd(scope.row)" plain>新增</el-button>
              <el-button size="mini" type="primary" @click="handleEdit(scope.row)" plain>编辑</el-button>
              <el-button size="mini" type="danger" @click="delLeft(scope.row)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>


    <!-- 添加/编辑服务分类 -->
    <el-dialog :title="serveTitle" width="600px" :visible.sync="serveDialog">
      <el-form :model="serveForm" ref="serveRef" :rules="rules" label-width="80px" class="px20">
        <el-form-item label="上级分类" prop="pid" v-if="showPid">
          <el-cascader style="width: 100%;" placeholder="请选择上级分类" v-model="serveForm.pid" :props="treeProps"
            :options="leftList"></el-cascader>
        </el-form-item>
        <el-form-item label="服务项目" prop="name">
          <el-input
            v-model="serveForm.name"
            autocomplete="off"
            placeholder="请输入服务项目名称"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="serveDialog = false">取 消</el-button>
        <el-button type="primary" @click="serveSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { Modal } from "ant-design-vue";
export default {
  data(){
    return {
      search_form: {
        name: '',
      },
      loading: false,
      leftIndex: 0,
      leftItem: {},
      leftList: [],
      treeProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true 
      },

      serveDialog: false,
      serveTitle: '',
      serveForm: {},
      showPid: false,
      rules: {
				pid: [{ required: true, message: "请选择上级分类", trigger: "change", }],
				name: [{ required: true, message: "请输入服务项目名称", trigger: "blur", }],
      },

      areaList: this.$store.state.areaList,
      tableData: [],
      isExpandAll: false,
    }
  },
  computed: {
    changeTime(){
      return function(time, type){
        type = type ? type : 'YYYY-MM-DD hh:mm:ss'
        return moment(time).format(type)
      }
    },
    videoTime(){
      return function(mss) {
        var days = parseInt(mss / (1000 * 60 * 60 * 24));
        var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = parseInt((mss % (1000 * 60)) / 1000);
        if (days > 0) {
          return `${days}天${hours<10 ? '0'+hours : hours}小时${minutes<10 ? '0'+minutes : minutes}分钟${seconds<10 ? '0'+seconds : seconds}秒`
        }
        if (hours > 0) {
          return `${hours<10 ? '0'+hours : hours}:${minutes<10 ? '0'+minutes : minutes}:${seconds<10 ? '0'+seconds : seconds}`
        }
        return `${minutes<10 ? '0'+minutes : minutes}:${seconds<10 ? '0'+seconds : seconds}`
      }
    },
    moment: () => moment,
    formatLength() {
      return (num) => {
        const min = Math.floor(parseInt(num) / 1000 / 60);
        const sec = Math.floor(parseInt(num) / 1000 - 60 * min);
        return `${min.toString().padStart(2, "0")}:${sec
          .toString()
          .padStart(2, "0")}`;
      };
    },
  },
  methods: {
    _getData() {
      this.$axios.get(`/api/qhd/ScienceService/findTreeScienceService`, { name: this.search_form.name }).then(res=>{
        if (res.code == 200) {
          console.log(res.data);
          this.leftList = res.data
          if(res.data.length) {
            this.leftIndex ? this.clickItem(this.leftIndex) :  this.clickItem(0)
          }
        }
      })
    },
    clickItem(i) {
      this.$nextTick(() => {
        this.leftIndex = i
        this.leftItem = this.leftList[i]
        this.tableData = this.leftList[i].children
      })
    },      
    handleCommand(command,item) {
      switch (command) {
        case 'edit':
          // 代码块 1
          this.editLeft(item)
          break;
        case 'del':
          // 代码块 2
          this.delLeft(item)
          break;
        default:
          // 默认代码块
          break;
      }
    },
    addType() {
      this.serveTitle = '新增服务'
      this.showPid = false
      this.serveDialog = true
      this.serveForm = {
        pid: ''
      }
    },
    editLeft(item) {
      console.log('editLeft');
      this.serveForm = JSON.parse(JSON.stringify(item))
      this.serveTitle = '编辑服务'
      this.showPid = false
      this.serveDialog = true
    },
    delLeft(item) {
      this.$confirm(`确定删除该项目?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this._delServe(item)
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消",
        });
      });
    },
    addNew() {
      this.serveTitle = '新增服务'
      this.showPid = false
      this.serveDialog = true
      this.serveForm = {
        pid: this.leftItem.id
      }
    },
    handleAdd(e) {
      console.log(e);
      this.serveTitle = '新增服务'
      this.showPid = true
      this.serveDialog = true
      this.serveForm = {
        pid: e.id
      }
    },
    handleEdit(e) {
      this.serveTitle = '编辑服务'
      this.showPid = true
      this.serveDialog = true
      this.serveForm = JSON.parse(JSON.stringify(e))
    },
    reset(form) {
      for (let key in form) {
        form[key] = null;
      }
    },
    refreshList() {
      this.search_form.name = ''
      this._getData()
    },
    operation(type){
      switch(type) {
        case 'search':
          this.leftIndex = 0
          this._getData()
          break;
        case 'reset':
          this.refreshList()
          break;
        case 'add':
          this.addNew()
          break;
      }
    },

    handleDel(e) {
      console.log(e);
      Modal.confirm({
        title: "操作确认",
        content: `确定删除该服务？`,
        onOk: () => {
          
        },
        onCancel() {},
      });
    },
    _addServe() {
      this.$axios.post("/api/qhd/ScienceService/addScienceService", this.serveForm).then((res) => {
        if (res.code == 200) {
          this.$message.success("添加成功");
          this.serveDialog = false
          this.refreshList()
        }
      });
    },
    _editServe() {
      this.$axios.post("/api/qhd/ScienceService/updateScienceService", this.serveForm).then((res) => {
        if (res.code == 200) {
          this.$message.success("编辑成功");
          this.serveDialog = false
          this.refreshList()
        }
      });
    },
    _delServe(e) {
      this.$axios.get(`/api/qhd/ScienceService/scienceServiceremoveById?id=${e.id}`,).then((res) => {
        if (res.code == 200) {
          this.$message.success("删除成功");
          this.refreshList()
        }
      });
    },
    serveSubmit() {
      this.$refs["serveRef"].validate((valid) => {
        if (valid) {
          console.log(this.serveForm);
          this.serveForm.id ? this._editServe() : this._addServe()
        } else {
          return false;
        }
      });
    },
  },
  created(){
    this._getData()
  }
}
</script>

<style lang="less" scoped>
  .serveIndex {
    width: 100%;
    height: 100%;
    .flexCont {
      display: flex;
      width: 100%;
      height: 100%;
    }
    .leftSide {
      width: 260px;
      margin-right: 25px;
      padding-right: 20px;
      border-right: 1px solid #272c4d;
      .leftHead {
        font-size: 16px;
        .el-icon-plus {
          width: 28px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          font-size: 17px;
          color: #999;
          cursor: pointer;

          &:hover {
            background: rgba(31, 35, 41, 0.1);
            border-radius: 4px;
          }

          &:active {
            background: rgba(31, 35, 41, 0.2);
            border-radius: 4px;
          }
        }
      }
      .el-icon-more {
        color: #fff;
      }
      .leftItem {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        font-size: 16px;
        line-height: 36px;
        &.cur {
          color: #fff;
          border-radius: 4px;
          background: #1890FF;
        }
      }
    }
    .rightSide {
      flex: 1;
      min-width: 0;
      width: 100%;
      overflow-y: scroll;

      .sodeScroll {
        padding: 25px 25px 25px 0;
      }
    }
  }


</style>
<style lang="less">
.serveIndex {
  .el-table th {
    color: #BCBCBC;
    background-color: #21284b !important;
  }
  .el-table__body {
    background-color: #0f132a;
  }
}
</style>